<template>
  <div id="questionview">
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <h1>Users Admin</h1>
      </v-row>
    </v-container>
    <div>
      <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <div class="filtersub">
       <!-- 
       <div class="first">
         <v-select
          :items="categorylist"
           v-model="category"
           label="Select Category"
           item-text="primary_category"
           item-value="id"
           outlined></v-select>
       </div>
       -->
       <div class="second">
          <v-text-field  v-model="search"  label="Type Name" class="mx-4 searchplayer"></v-text-field> 
       </div> 
       <div class="third">
           <v-btn color="primary text-center" @click.prevent="searchdata">Search</v-btn>
       </div>
    </div>
    <!--  :search="search"  -->
     <v-data-table 
       :headers="headers" 
       :mobile-breakpoint="0" 
       :items="itemsWithSno"  
      
       hide-default-footer  
       disable-pagination  >
       <template v-slot:item="{ item }"  >
        
         <tr :class="item.color">
          <td>{{ item.damnnId }}</td>
          <td class="text-left">
           <router-link :to="{name: 'user-transactions', params:{ userid: item.id }}"> {{ item.firstname }} {{ item.lastname }} </router-link>
            <!---
            <div class="options">
              <div v-if="item.option_a">A. {{item.option_a}}</div> 
              <div v-if="item.option_b">B. {{item.option_b}}</div>
              <div v-if="item.option_c">C. {{item.option_c}}</div>
              <div v-if="item.option_d">D. {{item.option_d}}</div>
            </div>-->
          </td>
           <td class="text-left">
             <div class="options">
              <div :key="item.id">$ {{item.inbank.balance}}</div> 
             </div>
           </td>
           <td class="text-left">
             <div class="options">
              <div :key="item.id">{{item.inbank.kels}}</div> 
             </div>
           </td>
          <td>
            <div class="options">
              <div @click="blockedUser(item,item.sno)">{{ (item.block_user_id==1) ? "Unblocked" : "Blocked" }}</div>
              <!--<div >add payment</div>-->
              <v-btn :disabled="makedisable" @click="editItem(item,item.sno)" color="primary">Add Payment</v-btn>
            </div>
           </td>
        </tr>
      </template>   
     </v-data-table>
     <infinite-loading  @infinite="getList"></infinite-loading>
    </div>
    <v-dialog v-model="dialog" max-width="650px">
     <v-card>
      <v-card-title>
        <span>Add Funds</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
             <v-radio-group
      v-model="editedItem.type"
      row
    >
    <v-radio
        label="Currency"
        value="currency"
      ></v-radio>
      <v-radio
        label="Kels"
        value="kels"
      ></v-radio>
             </v-radio-group>
           
          </v-row>

          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-text-field v-model="editedItem.amount" label="Amount"></v-text-field>
            </v-col>
          </v-row>
          
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-text-field v-model="editedItem.otp" label="Enter OTP Number"></v-text-field>
            </v-col>
          </v-row>
       
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
        <v-btn color="blue darken-1" text @click="save">Save</v-btn>
      </v-card-actions>
     </v-card>
    </v-dialog>

     <v-dialog v-model="userdialog" max-width="650px">
     <v-card>
      <v-card-title>
        <span>Block User</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              Are you sure want to {{ (this.blockUser.block_user_id==1) ? "Unblocked this user ?" : "Blocked this user ?" }}
            </v-col>
          </v-row>
          
       
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="blockclose">Cancel</v-btn>
        <v-btn color="blue darken-1" text @click="blocksave">Save</v-btn>
      </v-card-actions>
     </v-card>
    </v-dialog>
  </div>  

</template>
<script>
export default {
  name: "Userslist",
  data() {
    return {
      mobileBreakpoint: 600,
      dialog:false,
      userdialog:false,
      error: false,
      errorText:'',
      desserts:[],
      editedItem:[],
      blockUser:[],
      search:'', 
      page:1,
      categorylist:'',
      category:'',
      overlay: false,
      optionval:'',
      sno1:'',
      blocked:"",
      makedisable:false
    };
  },
  computed: {
     headers(){
        let headers = [
              { text:"DamnN Id", value: "sno" },
              { text:"Name  ",align: "question",value: "question",sortable: true},
              { text:"DammN Bank", value: "Balance" },
              { text:"DammN Kels", value: "Balance" },
              { text:"Action", value: "" },
         ]
         return headers
      },
       itemsWithSno() {
         return this.desserts.map((d, index) => ({ ...d, sno: index + 1,keyval:index }))
       },
  },
  created(){
     this.getCategories();
  },
  methods: {
    close(){
       this.editedItem = [];
       this.dialog     = false;
       this.addpayment='';
       this.sno1 = '';
    },
    save(){
      var add_user_id = this.editedItem.id;
      var amount   = this.editedItem.amount;
      var type   = this.editedItem.type;
      var otp   = this.editedItem.otp;
      this.$store.dispatch("updateInbank",
        {
          "type":type,"add_user_id":add_user_id,"amount":amount,"otp":otp
        }).then(() => {
         this.dialog = false;
         if(type=='currency')
         {this.desserts[this.sno1-1].inbank.balance = parseFloat(parseFloat(this.desserts[this.sno1-1].inbank.balance) + parseFloat(amount,2),2);}
         else if(type=='kels')
         {this.desserts[this.sno1-1].inbank.kels = parseFloat(parseFloat(this.desserts[this.sno1-1].inbank.kels) + parseFloat(amount,2),2);}
         //console.log(this.desserts[1].inbank.balance);
      });
    },
    blockclose(){
       this.blockUser = [];
       this.userdialog  = false;
       this.sno1 = '';
       this.blocked="";
    },
    blocksave(){
      var add_user_id = this.blockUser.id;
      
      
      this.$store.dispatch("blockedUser",
        {
          "add_user_id":add_user_id
        }).then(() => {
         // this.blockUser = [];
          this.userdialog  = false;
         // this.sno1 = '';
          //this.blocked="";
         //this.desserts[this.sno1-1].block_user =;
         //console.log(this.desserts[1].inbank.balance);
      });
    },
    editItem(item,sno1){
       this.editedItem = item;
       this.optionval  = this.editedItem.answer;
       this.makedisable = true;
      //
       this.$store.dispatch("getMyData",{userid:item.id}).then(() => {
          this.dialog     = true;
          this.makedisable = false;
       });
       this.sno1 = sno1;
    },
    blockedUser(user,sno1){
       this.blockUser = user;
       this.userdialog     = true;
       this.sno1 = sno1;
    },
    searchdata(){
       var parameter = "";
       if(this.category != '')
       {
         parameter = parameter+"category_d="+this.category;
       }

       if(this.search != '')
       {
         parameter = parameter+"name="+this.search;
       } 
       this.overlay = true;
       //this.desserts = [];
       this.$store.dispatch("getUsersList",{paramters:parameter}).then((response) => 
       {
          this.desserts = response.data;
          this.overlay = false;
       });
    }, 
    getList($state)
    {
       var parameter = "page="+this.page;
       if(this.category != '')
       {
         parameter = parameter+"&category_d="+this.category;
       }

       if(this.search != '')
       {
         parameter = parameter+"&question_string="+this.search;
       } 
       
       this.$store.dispatch("getUsersList",{paramters:parameter}).then((response) => {
          if(response.data.length > 0)
          {
             this.page += 1;
             this.desserts.push(...response.data);
             $state.loaded();
          }
          else
          {
            $state.complete();
          }
       });
     },
     getCategories(){
       this.$store.dispatch("getQuestionCategories").then((response) => {
          this.categorylist = response.data;
       });
     }
  }
};
</script>
<style scoped>
.options {
    display: flex;
    justify-content: space-between;
    margin-top: 8px;
    margin-bottom: 8px;
}
.radio-single-sec {align-items: center;}
.filtersub{display:flex; width:98%;margin:auto;align-items: center;}
.filtersub div.first{flex: 0 0 20%}
.filtersub div.second{flex: 0 0 91%}
.filtersub div.third{flex: 0 0 10%}
.radio-single-sec .first {flex: 0 0 15%;}
.radio-single-sec .second {flex: 0 0 85%;}

</style>